// @ts-nocheck
// @ts-ignore
// eslint-disable-next-line import/no-unresolved
import { LoginEvents } from '@cirkay-eng/cirkay-components/login-events';
// @ts-ignore
// eslint-disable-next-line import/no-unresolved
import { UnlockEvents } from '@cirkay-eng/cirkay-components/unlock-events';

const unlockContent = (sessionId, apiKey, elements) => {
	const contentRequired = [];
	elements.forEach((element) => {
		element.removeAttribute('data-locked');
		const contentLocked = element.dataset.lockedContent;
		if (contentRequired.indexOf(contentLocked) === -1) {
			contentRequired.push(contentLocked);
		}
	});
	const requestData = {
		action: 'get_fan_pass_content',
		nonce: cirkay_fan_pass.nonces.fan_pass_content,
		content: contentRequired,
	};

	if (contentRequired.length === 0) {
		return;
	}

	fetch(cirkay_fan_pass.ajax_url, {
		method: 'POST',
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded',
			'Session-Token': `${sessionId}`,
			'Fp-Key': `${apiKey}`,
		},
		body: new URLSearchParams(requestData).toString(),
	})
		.then((response) => {
			if (response.ok) {
				return response.json();
			}
			return Promise.reject(response);
		})
		.then((data) => {
			if (!data.success) {
				console.error('Error', data.data);
				return;
			}
			elements.forEach((element) => {
				if (data.data.content[element.dataset.lockedContent]) {
					const unlockedContent = document.createElement('div');
					unlockedContent.dataset.unlockedContent =
						element.dataset.lockedContent;
					unlockedContent.dataset.fpConnectedContent = true;
					unlockedContent.innerHTML =
						data.data.content[
							element.dataset.lockedContent
						].post_content;
					const textConnect = document.querySelector(
						'[data-fp-connected-promt]'
					);
					if (textConnect) {
						textConnect.style.display = '';
					}

					const textConnected = document.querySelector(
						'[data-fp-connect-promt]'
					);

					if (textConnected) {
						textConnected.style.display = 'none';
					}

					const preview = element.querySelector('[data-preview]');
					if (preview) {
						preview.style.display = 'none';
					}
					element.appendChild(unlockedContent);
				}
			});

			//NOT SURE ABOUT THIS
			//const event = new Event("DOMContentLoaded", { bubbles: true, cancelable: true });
			//document.dispatchEvent(event);
		})
		.catch((error) => {
			console.error('Error', error);
		});
};

document.addEventListener(LoginEvents.Logout, () => {
	const elements = document.querySelectorAll(`[data-fb-locked]`);
	elements.forEach((element) => {
		element.setAttribute('data-locked', 'true');
		const content = document.querySelector(`[data-fp-connected-content]`);
		const connected = document.querySelector('[data-fp-connected-promt]');
		const connect = document.querySelector('[data-fp-connect-promt]');
		if (connected) {
			connected.style.display = 'none';
		}
		if (connect) {
			connect.style.display = '';
		}
		if (content) {
			element.removeChild(content);
			element.querySelector('[data-preview]').style.display = '';
		}
	});
});

document.addEventListener(UnlockEvents.UnlockComplete, (event) => {
	if (event.detail.unlocked) {
		//sessionData = event.detail;
		unlockContent(
			event.detail.sessionToken,
			event.detail.apiKey,
			document.querySelectorAll(
				`[data-locked][data-fb-locked][data-fan-pass-api-key="${event.detail.apiKey}"]`
			)
		);
	}
});
